export const titlePrefix = '2048';
export const description = '2048 Clone';
export const googleAnalyticsId = 'UA-XXXXX-X';



/** WEBPACK FOOTER **
 ** ./src/config.js
 **/